export const INTERESTING_REACTION_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <g clipPath="url(#clip0_2952_73481)">
      <path
        fill="#fff"
        d="M7.5 16.667V15.5h5v1.167c0 .618-.263 1.212-.732 1.65A2.594 2.594 0 0110 19a2.593 2.593 0 01-1.768-.683 2.257 2.257 0 01-.732-1.65zm5-2.334c.019-.396.26-.753.596-1.002a4.667 4.667 0 001.703-2.354 4.372 4.372 0 00-.075-2.84 4.712 4.712 0 00-1.825-2.273A5.248 5.248 0 0010 5a5.248 5.248 0 00-2.899.864 4.711 4.711 0 00-1.825 2.273 4.372 4.372 0 00-.075 2.84c.292.93.887 1.753 1.703 2.354.337.249.577.606.595 1.002H12.5 12.5z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 0a1 1 0 011 1v1a1 1 0 11-2 0V1a1 1 0 011-1zM2.929 2.929a1 1 0 011.414 0l.707.707A1 1 0 013.636 5.05l-.707-.707a1 1 0 010-1.414zm14.142 0a1 1 0 010 1.414l-.707.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM10 6a4 4 0 00-2.83 6.828l.548.546c.193.193.367.403.519.625h3.526c.153-.223.326-.432.518-.624l.548-.547A4 4 0 0010 6.001zM11.025 16h-2.05c.017.155.025.312.025.469V17a1 1 0 102 0v-.53c0-.158.008-.314.025-.47zm-4.276-.593A2.376 2.376 0 017 16.47V17a3 3 0 106.001 0v-.531a2.375 2.375 0 01.695-1.679l.548-.547a6 6 0 10-8.486 0l.548.547c.182.182.331.391.444.617zM0 10a1 1 0 011-1h1a1 1 0 110 2H1a1 1 0 01-1-1zm17 0a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2952_73481">
        <path fill="#fff" d="M0 0H20V20H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
